import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-update-name-dialog",
  templateUrl: "./update-name-dialog.component.html",
  styleUrls: ["../../../dashboard.style.scss"],
})
export class UpdateNameDialogComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<UpdateNameDialogComponent>) {}

  nameControl: FormControl;

  ngOnInit(): void {
    this.nameControl = new FormControl("", Validators.required);
  }

  onUpdate() {
    if (!this.nameControl.valid) return;
    this.dialogRef.close(this.nameControl.value);
  }
}
